import { ReactNode } from "react";
import { PollinatorLogo } from "@shared/ui/PollinatorLogo";
import { Type } from "@shared/ui/Type";

type Props = {
  children: ReactNode;
  title: string;
  description: string;
};

export function AuthContent({ children, title, description }: Props) {
  return (
    <div className="flex flex-col border border-brand-800 rounded-lg w-full max-w-xl mx-auto shadow-lg">
      <div className="flex flex-col items-center justify-center p-8 gap-8">
        <div className="flex flex-col items-center justify-center gap-4 w-full max-w-sm mx-auto">
          <PollinatorLogo className="mx-auto" size="sm" />
          <Type as="h1" variant="h3" className="text-center">
            {title}
          </Type>
          <Type as="p" variant="body1" className="text-center">
            {description}
          </Type>
        </div>
        <div className="w-full max-w-sm mx-auto flex flex-col gap-8">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthContent;
